import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { Alert } from '@/app/components/ui/Alert';

const AlertError = () => {
  const t = useTranslations();
  const searchParams = useSearchParams();
  const errorParam = searchParams.get('error');

  if (!errorParam) {
    return null;
  }

  const message =
    errorParam === 'SessionExpired'
      ? t('signin_session_expired_message')
      : t('signin_login_error_message');

  return (
    <Alert
      icon="ALERT_04"
      variant="error"
      title={message}
      className="w-full max-w-none"
    />
  );
};

export default AlertError;
